module.exports = __webpack_public_path__ + "static/img/experience-pic3.0467a0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience-pic3.png
// module id = pOxK
// module chunks = 0